export default {
  // Default export is a Vue plugin
  install (Vue) {
    // Read more about instance properties on https://vuejs.org/v2/cookbook/adding-instance-properties.html#Base-Example
    Vue.prototype['$script'] = {
      /**
       * Inject 3rd party script into the head of the page (only once)
       * @param {string} src 
       */
      load (src, inHead = true) {
        return new Promise(function (resolve, reject) {
          if (typeof (document) === 'undefined') { reject('Could not find DOM') }
          let shouldAppend = false
          let el = document.querySelector(`script[src="${src}"]`)
          if (!el) {
            el = document.createElement('script')
            el.type = 'text/javascript'
            el.async = true
            el.src = src
            shouldAppend = true
          } else if (el.hasAttribute('data-loaded')) {
            resolve(el)
            return
          }
  
          el.addEventListener('error', reject)
          el.addEventListener('abort', reject)
          el.addEventListener('load', function loadScriptHandler () {
            el.setAttribute('data-loaded', true)
            resolve(el)
          })
  
          if (shouldAppend) {
            if (inHead) {
              document.head.appendChild(el)
            } else {
              document.body.appendChild(el)
            }
          }
        })
      },
      /**
       * Remove 3rd party script from the head of the page
       * @param {string} src
       */
      unload (src) {
        return new Promise(function (resolve, reject) {
          if (typeof (document) === 'undefined') { reject('Could not find DOM') }
          const el = document.querySelector(`script[src="${src}"]`)
          if (!el) {
            resolve()
            return
          }
          el.parentNode.removeChild(el)
          resolve()
        })
      },
    }
  },
}
